

import {
    GET_EMANDATE_DETAILS_SUCCESS, GET_EMANDATE_DETAILS_FAILURE, SAVE_EMANDATE_TOKEN_SUCCESS, SAVE_EMANDATE_TOKEN_FAILURE,
    SAVE_EMANDATE_RESPONSE_SUCCESS, SAVE_EMANDATE_RESPONSE_FAILURE
} from '../../types/trans'


const initialState = {
    GetEmandateDetails: {},
    SaveEmandateResponse: {},
    SaveEmandateToken: {}
}



export default function reducer(state = initialState, action) {
    switch (action.type) {
        case GET_EMANDATE_DETAILS_SUCCESS:
            return { ...state, GetEmandateDetails: action.payload }
        case GET_EMANDATE_DETAILS_FAILURE:
            return { ...state, GetEmandateDetails: action.payload }
        case SAVE_EMANDATE_TOKEN_SUCCESS:
            return { ...state, SaveEmandateToken: action.payload }
        case SAVE_EMANDATE_TOKEN_FAILURE:
            return { ...state, SaveEmandateToken: action.payload }
        case SAVE_EMANDATE_RESPONSE_SUCCESS:
            return { ...state, SaveEmandateResponse: action.payload }
        case SAVE_EMANDATE_RESPONSE_FAILURE:
            return { ...state, SaveEmandateResponse: action.payload }
        default:
            return state
    }

}